import { render, staticRenderFns } from "./OrderItemAttachmentMediaCreateModal.vue?vue&type=template&id=35da4735"
import script from "./OrderItemAttachmentMediaCreateModal.vue?vue&type=script&lang=js"
export * from "./OrderItemAttachmentMediaCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports